import React from "react";
import styled from "styled-components";

export default function PrivatlivspolitikPagePage() {
  return (
    <HandelsWrapper>
      <h1>Privatlivspolitik</h1>

      <section>
        <h2>1. Introduktion</h2>
        <p>
          Velkommen til Atapizza. Vi respekterer dit privatliv og beskytter de
          oplysninger, du giver os, når du bruger vores hjemmeside.
        </p>
      </section>

      <section>
        <h2>2. Hvilke oplysninger indsamler vi?</h2>
        <p>
          Navn, telefon, email, adresse og eventuelle kommentarer. Ingen
          betaling gemmes på hjemmesiden.
        </p>
      </section>

      <section>
        <h2>3. Hvordan bruger vi dine oplysninger?</h2>
        <p>
          Vi bruger oplysningerne til at behandle bestillinger, kommunikere og
          forbedre vores service.
        </p>
      </section>

      <section>
        <h2>4. Cookies og tracking</h2>
        <p>
          Vi bruger cookies kun efter samtykke for analyse og brugeroplevelse.
        </p>
      </section>

      <section>
        <h2>5. Sikkerhed</h2>
        <p>
          Oplysninger behandles fortroligt og beskyttes mod uautoriseret adgang.
        </p>
      </section>

      <section>
        <h2>6. Deling af oplysninger</h2>
        <p>Vi deler kun med leveringspartnere eller ved lovkrav.</p>
      </section>

      <section>
        <h2>7. Dine rettigheder</h2>
        <p>
          Adgang, rettelse, sletning og tilbagetrækning af samtykke kan ske via
          telefon eller kontaktformular.
        </p>
      </section>

      <section>
        <h2>8. Ændringer i privatlivspolitikken</h2>
        <p>Ændringer offentliggøres på hjemmesiden.</p>
      </section>
    </HandelsWrapper>
  );
}

/* ===============================
   Styled Components (nederst)
   =============================== */

const HandelsWrapper = styled.section`
  max-width: 900px;
  margin: 0 auto;
  padding: 20px 16px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI",
    sans-serif;
  color: #222;

  h1 {
    font-size: 1.8rem;
    margin-bottom: 1.5rem;
    text-align: center;
  }

  section {
    margin-bottom: 1.6rem;
  }

  h2 {
    font-size: 1.15rem;
    margin-bottom: 0.4rem;
    color: #111;
  }

  p {
    font-size: 0.95rem;
    line-height: 1.6;
    margin: 0.2rem 0;
  }

  strong {
    font-weight: 600;
  }

  @media (max-width: 600px) {
    padding: 16px 12px;

    h1 {
      font-size: 1.5rem;
    }

    h2 {
      font-size: 1.05rem;
    }

    p {
      font-size: 0.92rem;
    }
  }
`;
